import { createContext } from "react"
import { Project, ResponseStatus } from "../../api/dtos";

export interface IProjectContext {
    data?: Project;
    oid?: string;
    error?: ResponseStatus;
    loading: boolean;
    validating: boolean;
    refresh: () => Promise<Project | undefined>
}

export const ProjectContext = createContext<IProjectContext>({
    loading: false,
    validating: false,
    data: undefined,
    error: undefined,
    refresh: () => {
        return new Promise<Project | undefined>(res => {
            res(undefined);
        });
    }
});

export default ProjectContext;